// Fold & Press Station - Final finishing department
import React from 'react';
import { RefreshCw } from 'lucide-react';
import BaseStationScreen from '../components/BaseStationScreen';

const FoldPressStation: React.FC = () => {
  return (
    <BaseStationScreen
      stationId="fold-press"
      stationName="Fold & Press"
      stationIcon={<RefreshCw className="w-6 h-6" />}
      stationColor="#F59E0B"
      showAdvanceButton={true}
      showCustomerContact={false}
      showDeliveryInfo={false}
    />
  );
};

export default FoldPressStation;
